import React from "react";
import LinkTable from "./List/SocialList";
import "../../../components/common/css/datatable.scss";
import "../../../components/common/css/index.scss";

const Team = () => {
  
  return (
    <div className="list">
      <div className="listContainer">
        <LinkTable/>
      </div>
    </div>
  );
};

export default Team;
